import React from 'react';

import logoLC from "../../images/ioai/logo_lc.png";
import logoAIML from "../../images/ioai/logo_aiml.png";
import logoSAChineseNews from "../../images/ioai/logo_sa_chinese_news.jpg";
import logoAAEGT from "../../images/ioai/logo_AAEGT.jpg";
import logoChess from "../../images/ioai/logo_chess.png";
import logoGTCASA from "../../images/ioai/logo_GTCASA.jpg";
import logoSA from "../../images/ioai/logo_sa.png";
import logoUoA from "../../images/ioai/logo_uoa.png";
import logoCityMedical from "../../images/ioai/logo_citymedical.png";
import logoSkinTech from "../../images/logo/skintech.jpg";
import logoHerTechPath from "../../images/logo/hertechpath.png";

const images = [
    {
        img: logoLC,
        url: "https://www.leadingcoding.com.au",
    },
    {
        img: logoAIML,
        url: "https://www.adelaide.edu.au/aiml",
    },
    {
        img: logoSAChineseNews,
        url: "https://www.sacn.com.au",
    },
    {
        img: logoAAEGT,
        url: "https://www.aaegt.com",
    },
    {
        img: logoChess,
        url: "https://sajuniorchess.org",
    },
    {
        img: logoGTCASA,
        url: "https://www.gtcasa.com.au",
    },
    {
        img: logoSA,
        url: "https://www.unisa.edu.au/about-unisa/academic-units/justice-and-society",
    },
    {
        img: logoUoA,
        url: "https://set.adelaide.edu.au/computer-and-mathematical-sciences",
    },
    {
        img: logoCityMedical,
        url: "",
    },
    {
        img: logoSkinTech,
        url: "",
    },
    {
        img: logoHerTechPath,
        url: "https://hertechpath.org",
    },
];

const PartnerScroll = () => {
    return (
        <div>
            <div className="image-container">
                <div className="image-wrapper">
                    <div className="images">
                        {images.map((image, index) => (
                            <a href={image.url} key={index} target="_blank" rel="noopener noreferrer">
                                <img className="image" src={image.img} alt={`Slide ${index + 1}`} />
                            </a>
                        ))}
                    </div>
                    <div className="images">
                        {images.map((image, index) => (
                            <a href={image.url} key={index} target="_blank" rel="noopener noreferrer">
                                <img className="image" src={image.img} alt={`Slide ${index + 1}`} />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PartnerScroll;